import React, { Component } from 'react'
import Form from './Form';
import Http from '../../Http';

export class Validators {
  static required = (val: any) => {
    if (!val || val.length < 1) return false;
    return true;
  }
}

export interface FormOption {
  value: any,
  label: string
}
export interface FormField {
  type: string,
  name: string,
  label: string,
  value: string,
  validators: Validators[],
  col: number,
  options: FormOption[],
  invalid: boolean,
  blur: boolean,
  [key: string]: string | Validators[] | number | FormOption[] | boolean;
}
export interface FormGroup {
  fields: FormField[],
  options: string[],
  title: string,
  invalid: boolean,
}

export class FormOp {
  // { type: 'text', name: 'od_lugar', label: 'Clave', value: '', col: 4, validators: [Validators.required] },
  static Field(type: string, name: string, label: string, value: string, validators: Validators[], col: number, options: FormOption[] = []): FormField {
    return {
      type, name, label, value, validators, col, options: options, invalid: true, blur: false
    }
  }

  static Group(fields: FormField[] = [], options: string[] = [], title: string = ''): FormGroup {
    // fields.push({type: 'id', name: 'id', label: ''})
    return {
      fields, options, title, invalid: true
    }
  }

  static ModField(formGroup: FormGroup, fieldName: string, fieldProp: any, newVal: any) {
    var fieldIndex = formGroup.fields.findIndex((field) => field.name === fieldName);
    formGroup.fields[fieldIndex][fieldProp] = newVal;
    return formGroup;
  }

  static ModOptions(formGroup: FormGroup, fieldName: string, newOptions: any[], opVal: string, opLabel: string) {
    var format: FormOption[] = newOptions.map((option) => ({ value: option[opVal], label: option[opLabel] }))
    return FormOp.ModField(formGroup, fieldName, 'options', format);
  }
}
export interface FormConfig {
  defaultUrl?: string;
  saveUrl?: string;
  backUrl?: string;
}

export default class FormComponent extends Component<{ match: any, onSave: any, history: any }, { formData: any, formDefault: any }> {

  private config: FormConfig = {}

  state = {
    formData: FormOp.Group(),
    // formData: null,
    formDefault: null
  }

  // componentDidMount() {
  //   console.log(this.props.match);

  //   if (this.props.match.params.id)
  //     this.loadFormPreds(this.props.match.params.id)
  // }

  // formData = () => { }

  formConfig = (config: FormConfig, data: FormGroup, formFill: any = null) => {
    // console.log(data);
    // // console.log(await formFill(data));
    // if(formFill)
    //   Object.assign(data, await formFill(data))
    this.fillForm(data, formFill);
    this.config = config;
    this.setState({ formData: data })
  }

  fillForm = async (data: any, formFill: any) => {
    if (formFill) {
      Object.assign(data, await formFill(data))
      this.setState({ formData: data })
    }
  }

  loadFormPreds = async (id: any) => {
    let Res = await Http.get(`${this.config.defaultUrl}/${id}`);

    if (!Res.error)
      this.setState({ formDefault: Res.data })
  }

  submit = async (i: number, vals: any, load: any) => {
    vals.id = this.props.match.params.id;
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    // console.log(Res)
    if (!Res.error) {
      load('Guardado', true);
      this.props.history.push(`${this.config.backUrl}`)
      this.props.onSave();
    } else
      load('Error al guardar', false);

  }

  FormRender = () => {
    const { formData, formDefault } = this.state;
    const { params } = this.props.match;
    // console.log(formDefault);

    return (
      <div className="form-box">
        {/* {
          formData && */}
        <Form form={formData} onSubmit={this.submit} default={(!params.id) ? null : formDefault} />
        {/* } */}
      </div>
    )
  }

  // render() {
  //   return (
  //     <div>

  //     </div>
  //   )
  // }
}
